
const Header = ({skillsRef, latestRef, contactRef }) => {

const scrolToSkills = () => {
        skillsRef.current.scrollIntoView({behavior: 'smooth'});
}

const scrolToLatest = () => {
        latestRef.current.scrollIntoView({behavior: 'smooth'});
}

const scrolToContact = () => {
        contactRef.current.scrollIntoView({behavior: 'smooth'});
}
    return(
         
              <div className='personalNav'>
                     <div className='nav-item'>
                           <span onClick={scrolToSkills}>Skills</span>
                    </div>
                    <div className='nav-item'>
                            <span onClick={scrolToLatest}>Latest Personal Projects</span>
                    </div>
                    <div className='nav-item'>
                            <span onClick={scrolToContact}>Contact Me</span>
                    </div>
              </div>
         
        
    );
}

export default Header;